import "core-js/modules/es.promise.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { baseURL, handleAxiosError } from "./servicesUtils";
import axios from "axios";
var baseController = "".concat(baseURL, "/rest/agency");
export var sendAgencyContactAsync = data => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.post("".concat(baseController, "/agencyContacts"), data);
    return res.data;
  } catch (error) {
    handleAxiosError(error);
    throw error;
  }
});
export var sendAgencyContactNoEmailAsync = data => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.post("".concat(baseController, "/agencyContactsNoEmail"), data);
    return res.data;
  } catch (error) {
    handleAxiosError(error);
    throw error;
  }
});
export var getAgencyById = (agencyId, lang) => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.get("/rest/agency/getAgencyByIDLang/".concat(agencyId, "/").concat(lang));
    return res.data;
  } catch (error) {
    handleAxiosError(error);
    throw error;
  }
});
export var sendMortgage = data => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.post("/rest/agency/sendMutuo", data);
    return res.data;
  } catch (error) {
    handleAxiosError(error);
    throw error;
  }
});
export var sendFacileRequest = data => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.post("".concat(baseController, "/sendFacileServiceRequest"), data);
    return res.data;
  } catch (err) {
    handleAxiosError(err);
    throw err;
  }
});
export var getAgenciesData = ids => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.post("".concat(baseController, "/getAgencyListForInfoWindow"), ids);
    return res.data;
  } catch (e) {
    handleAxiosError(e);
    throw e;
  }
});
export var getMapMarkers = agencySearchBean => __awaiter(void 0, void 0, void 0, function* () {
  if (!window["_serializedAgencySearchBean"]) return;
  try {
    var res = yield axios.post("".concat(baseController, "/getAgenciesMarkers"), agencySearchBean, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      }
    });
    return res.data;
  } catch (err) {
    handleAxiosError(err);
    throw [];
  }
});